export class FuzzySearch {
    data;
    stringify;
    constructor(data, stringify){
        this.data = data;
        this.stringify = stringify // A function to convert each item to a string for comparison
        ;
    }
    // Simple fuzzy search method
    search(query, threshold = 0.5) {
        function escapeRegExp(str) {
            return str.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
        }
        // function to calculate the edit distance between two strings
        function editDistance(a, b) {
            if (a.length === 0) return b.length;
            if (b.length === 0) return a.length;
            const matrix = [];
            // increment along the first column of each row
            let i;
            for(i = 0; i <= b.length; i++){
                matrix[i] = [
                    i
                ];
            }
            // increment each column in the first row
            let j;
            for(j = 0; j <= a.length; j++){
                matrix[0][j] = j;
            }
            // Fill in the rest of the matrix
            for(i = 1; i <= b.length; i++){
                for(j = 1; j <= a.length; j++){
                    if (b.charAt(i - 1) === a.charAt(j - 1)) {
                        matrix[i][j] = matrix[i - 1][j - 1];
                    } else {
                        matrix[i][j] = Math.min(matrix[i - 1][j - 1], matrix[i][j - 1], matrix[i - 1][j] // deletion
                        ) + 1;
                    }
                }
            }
            return matrix[b.length][a.length];
        }
        // sort function using edit distance
        function sortStrings(query, a, b) {
            const aDist = editDistance(query, a);
            const bDist = editDistance(query, b);
            return aDist - bDist;
        }
        function fuzzyMatch(pattern, str) {
            pattern = ".*" + pattern.split("").map((l)=>`${escapeRegExp(l)}.*`).join("");
            const re = new RegExp(pattern);
            return re.test(str);
        }
        // function to remove all non-alphanumeric characters, including spaces and periods
        function removeNonAlphanumeric(str) {
            return str.replace(/[^a-zA-Z0-9]/g, "");
        }
        return this.data.filter((item)=>{
            const itemString = removeNonAlphanumeric(this.stringify(item).toLowerCase());
            const queryLower = removeNonAlphanumeric(query.toLowerCase());
            const match = fuzzyMatch(queryLower, itemString);
            return match;
        }).sort((a, b)=>sortStrings(query, this.stringify(a), this.stringify(b)));
    }
}
